@if (isParentFocused()) {
  <div class="relative my-1 flex flex-wrap items-center gap-1">
    @for (chip of chips; track chip) {
      <div
        class="flex items-center gap-1 rounded bg-slate-200 px-2 text-slate-800"
      >
        {{ chip }}
        <p-button
          size="small"
          severity="contrast"
          variant="text"
          styleClass="scale-[0.7]!"
          (onClick)="removeChip(chip)"
        >
          <ng-template #icon>
            <svg-icon src="/assets/icons/general/close.svg" />
          </ng-template>
        </p-button>
      </div>
    }
    <div class="relative flex items-center">
      <input
        autocomplete="off"
        type="text"
        [(ngModel)]="inputValue"
        (input)="handleInput($event)"
        (keydown)="handleKeyDown($event)"
        (focus)="handleFocus()"
        (blur)="handleBlur($event)"
        [placeholder]="placeholder()"
        [class]="{
          'text-orange-500!': inputState === 'duplicate',
          'text-red-500!': inputState === 'invalid',
        }"
        class="w-auto grow border-0!"
        id="email-input"
      />
      @if (isFocused && filteredSearchList.length > 0) {
        <div
          class="absolute top-full z-50 mt-2 w-72 rounded border bg-white p-3 shadow-lg"
          id="search-list-modal"
          [style.left]="leftInputValue"
        >
          <div class="grid max-h-28 grid-cols-1 overflow-y-auto">
            @for (item of filteredSearchList; track item) {
              <button
                type="button"
                class="flex w-full items-center gap-1 rounded px-1 py-2 text-left text-lg text-slate-800 hover:bg-slate-50"
                (mousedown)="selectItem(item)"
              >
                <div class="ml-3 w-full space-y-1 overflow-hidden">
                  <h1 class="w-full truncate" [title]="item">
                    {{ item }}
                  </h1>
                </div>
              </button>
            }
          </div>
        </div>
      }
      @if (inputState === "duplicate") {
        <div
          class="absolute bottom-full mb-1 rounded bg-orange-500 px-2 py-1 text-xs text-white shadow-lg"
        >
          You can't add the same {{ keyword() }} twice
        </div>
      }
      @if (inputState === "invalid") {
        <div
          class="absolute bottom-full mb-1 rounded bg-red-500 px-2 py-1 text-xs text-white shadow-lg"
        >
          This is not a valid {{ keyword() }}
        </div>
      }
    </div>
  </div>
}

@if (!isParentFocused()) {
  <div class="my-1 flex items-center">
    <span class="flex overflow-hidden whitespace-nowrap">
      {{ chips.join(", ") }}
    </span>
  </div>
}
